import React from 'react';
import { CodeBar } from 'vivace-fluent-motion';
import Td from './Td';
import IntlMessage from "../../../../../../../helpers/intlMessage";

const Table = ({ item }) => (
  <table style={{ width: '100%', marginBottom: '7px' }}>
    <tbody>
      <tr>
        <Td styleTd={{ padding: '0px 12px', width: '200px' }}>
          <CodeBar
            value={item.nrExame}
            width={1}
            margin={5}
            height={20}
            fontSize={12}
            lineColor={'#333'}
          />
        </Td>
        <Td title={<IntlMessage id = "dashboards.examDetail.table.exam"/>}
         value={item.exame} styleTd={{ width: '200px' }} />
        <Td
          styleTd={{ width: '200px' }}
          title={<IntlMessage id = "dashboards.examDetails.openExams"/>}
          value={item.totalExamesEmAberto}
        />
        <Td
          title={<IntlMessage id = "dashboards.reports.medicalRecord"/>}
          value={item.prontuario}
          styleTd={{ width: '200px' }}
        />
      </tr>
      <tr>
        <td
          colSpan={'1'}
          style={{
            border: '#eee solid 1px',
            fontSize: '12px',
            verticalAlign: 'center',
            padding: '4px 12px',
            width: '200px'
          }}
        >
          <div>
            <strong><IntlMessage id = "dashboards.examDetail.patient"/></strong>
            <span style={{ marginLeft: '5px' }}>{item.paciente}</span>
            {item.pacienteNomeSocial && <div><strong><IntlMessage id = "dashboards.general.socialName"/></strong>
              <span style={{ marginLeft: '5px' }}>{item.pacienteNomeSocial}</span></div>}
          </div>
        </td>
        <Td title={<IntlMessage id = "dashboards.reports.doctor"/>} value={item.medico} styleTd={{ width: '200px' }} />
        <Td title={<IntlMessage id = "dashboards.general.urgent"/>} value={item.urgente} styleTd={{ width: '200px' }} />
        <Td
          title={<IntlMessage id = "dashboards.examDetail.table.status"/>}
          value={item.statusText}
          styleTd={{ width: '200px' }}
        />
      </tr>
      <tr>
        <Td
          title={<IntlMessage id = "general.materialArchiving.requestDate"/>}
          value={item.dataPedido}
          styleTd={{ width: '200px' }}
        />
        <Td
          title={<IntlMessage id = "dashboards.reports.materialDelivered"/>}
          value={item.dataEntregaMaterial}
          styleTd={{ width: '200px' }}
        />
        <Td
          title={<IntlMessage id = "dashboards.reports.estimatedDelivery"/>}
          value={item.dataEntregaPrevista}
          styleTd={{ width: '200px' }}
        />
        <Td
          title={<IntlMessage id = "dashboards.reports.delivery"/>}
          value={item.dataEntrega}
          styleTd={{ width: '200px' }}
        />
      </tr>
    </tbody>
  </table>
);

export default Table;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Relatorios/LaudosCriticos/Impressao/Table/index.js